import { RemovableLabel, RemovableProps } from "components/Removables/Removable";
import { CompanySmallDetails, LayoutType } from "components/SmallDetails";
import React from "react";

interface Props extends RemovableProps<server.dto.CompanySmall> {
  hideEditButton?: boolean;
  layout: LayoutType;
}

const RemovableCompany = (props: Props) => {
  return <RemovableLabel {...props}>
    <div>
      <CompanySmallDetails
        company={props.value}
        layout={props.layout}
      />
    </div>

  </RemovableLabel>;
};

export default RemovableCompany;